import React, { useState } from "react";
import BaseBage from "../BasePage";
import { getNDVI } from "../../api/FlaskAPI";
import ndviLegend from "../../assets/images/NDVI_legend.png";
import MonitoringDialog from "../Masking/MonitoringDialog";
import Map from "../Masking/Map";
import CoordinatesInput from "../../components/CoordinatesInput";
import NavPageSelector from "../../components/NavPageSelector";
import SignInComponent from "../../components/Sign/SignComponent";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function NDVI() {
  const [open, setOpen] = useState(false);
  const areas = useSelector((state) => state.mapState.areas);

  const { type, index } = useParams();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <BaseBage
        key={index}
        dataKey={index}
        monitoringKey={index}
        endpoint={getNDVI}
        route="NDVI"
        legendImg={{ src: ndviLegend, style: "ndvi-legend-img" }}
      />
      {/* <div className="monitoring-container">
        <div className="map-wrapper">
          <NavPageSelector route={"masking"} />
          <div className="sign-up-container-base">
            <SignInComponent
              menuIconColor="black"
              backgroundColor="white"
              MT="0em"
              ML="0em"
              classN="modalcontainer-base"
            />
          </div>
          <CoordinatesInput disableFileUpload={false} />

          <Map />

          {/* side modal
          <div className="submit-compare-buttons-container">
            <button
              className="submit-compare-buttons"
              onClick={() => {
                if (!areas || !areas[0] || !areas[0].coordinates) {
                  toast.error(
                    "Please select the polygon you want to be predicted"
                  );
                } else {
                  handleOpen();
                }
              }}
            >
              Monitoring
            </button>
            <MonitoringDialog
              mainIndex="NDVI"
              open={open}
              handleClose={handleClose}
            />
          </div>
        </div>
      </div> */}
    </>
  );
}
